import { exclusiveInterviews } from '@/mocks/news';

export default function InterviewSection() {
  return (
    <section id="interview" className="scroll-mt-16 bg-foreground-950">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 flex items-end justify-between">
          <div>
            <p className="flex items-center gap-2 text-sm font-bold tracking-widest text-accent-500">
              <i className="ri-mic-line" aria-hidden="true" /> 独家专访 · 只此一家
            </p>
            <h2 className="mt-2 font-heading text-2xl font-black text-background-50 md:text-3xl">
              走进镜头之外的真实讲述
            </h2>
          </div>
          <span className="hidden whitespace-nowrap rounded-full border border-background-100/20 px-4 py-1.5 text-sm text-background-100 sm:block">
            受访者已授权 · 信源保密
          </span>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          {exclusiveInterviews.map((it, idx) => (
            <article
              key={it.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-100/15 bg-foreground-900/60"
            >
              <div className="relative h-56 w-full overflow-hidden">
                <img
                  src={it.image}
                  alt={it.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent" />
                <span className="absolute left-4 top-4 flex h-8 w-8 items-center justify-center rounded-full bg-accent-500 text-foreground-950">
                  <i className={idx === 0 ? 'ri-double-quotes-l' : 'ri-mic-2-fill'} aria-hidden="true" />
                </span>
                <span className="absolute bottom-3 left-4 whitespace-nowrap rounded-md bg-foreground-950/70 px-2.5 py-1 text-xs font-semibold text-accent-400 backdrop-blur-sm">
                  {it.tag}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg font-bold leading-snug text-background-50 transition-colors group-hover:text-accent-400">
                  {it.title}
                </h3>
                <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-background-100/75">
                  {it.summary}
                </p>

                <div className="mt-5 rounded-md border-l-2 border-accent-500 bg-foreground-950/70 px-4 py-3">
                  <p className="font-heading text-sm leading-relaxed text-background-100">
                    “热点可以被制造，但我们选择把它还原到只剩事实的那一层。”
                  </p>
                </div>

                <div className="mt-4 flex items-center justify-between text-xs text-background-100/60">
                  <span className="flex items-center gap-2">
                    <span className="flex h-6 w-6 items-center justify-center rounded-full bg-accent-500/20 text-accent-400">
                      <i className="ri-user-3-line text-xs" aria-hidden="true" />
                    </span>
                    {it.author} · {it.time}
                  </span>
                  <a
                    href="#topics"
                    className="flex items-center gap-1 whitespace-nowrap font-semibold text-accent-400 hover:text-accent-300"
                  >
                    读全文 <i className="ri-arrow-right-line" aria-hidden="true" />
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}